// extracted by mini-css-extract-plugin
export default {"root":"NavButtons__root--Ny88W","navButton":"NavButtons__navButton--36gIl","navButton_disabled":"NavButtons__navButton_disabled--1r-D9"};